"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.strikethrough = exports.spacingReset = exports.overflowStyling = exports.inlineIcon = exports.bodyStyles = exports.UnavailableChipText = exports.TagText = exports.TabText = exports.StyledAnchorTag = exports.RequiredText = exports.ListViewSecondaryInformation = exports.ListViewSecondaryCell = exports.ListViewPrimaryCell = exports.ListViewHeader = exports.Legend = exports.Label = exports.InputOption = exports.HelperText = exports.Eyebrow = exports.ErrorLabel = exports.DangerHelperText = exports.DangerChipText = exports.ChipText = exports.BodyStatus = exports.ActiveLabel = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = _interopRequireDefault(require("../typography/theme"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var spacingReset = exports.spacingReset = "\n  margin: 0;\n  padding: 0;\n  padding-inline-end: 0;\n  padding-inline-start: 0;\n";
var inlineIcon = exports.inlineIcon = "\n  > svg.seedling-birch-icon {\n    height: 1em;\n    width: 1em;\n\n    top: 0.125em;\n    position: relative;\n  }\n";
var overflowStyling = exports.overflowStyling = "\n  max-width: 150px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n";
var strikethrough = exports.strikethrough = function strikethrough(props) {
  if (props.strikethrough) {
    return 'text-decoration: line-through;';
  }
};
var BodyStatus = exports.BodyStatus = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var bodyStyles = exports.bodyStyles = (0, _styledComponents.css)(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", " ", " > svg.seedling-birch-icon{height:1.25rem;width:1.25rem;vertical-align:top;}"], _theme["default"].fonts.sans, function (_ref) {
  var medium = _ref.medium;
  return medium ? _theme["default"].fontWeights.medium : _theme["default"].fontWeights.normal;
}, function (props) {
  return props.theme.fontMediumSize;
}, function (props) {
  return props.theme.fontMediumLineHeight;
}, function (_ref2) {
  var status = _ref2.status,
    metadata = _ref2.metadata;
  if (status === BodyStatus.ACTIVE) {
    return _theme["default"].colors.active;
  } else if (metadata) {
    return _theme["default"].colors.metadata;
  } else {
    return _theme["default"].colors.primary;
  }
}, function (_ref3) {
  var excludeSpacingReset = _ref3.excludeSpacingReset;
  return !excludeSpacingReset && spacingReset;
}, inlineIcon, strikethrough);
var linkIconColorAndHeight = function linkIconColorAndHeight(color) {
  return "\n  > svg.seedling-birch-icon {\n    top: .175rem;\n    path {\n      fill: ".concat(color, ";\n    }\n  }\n");
};
var StyledAnchorTag = exports.StyledAnchorTag = _styledComponents["default"].a.withConfig({
  displayName: "internal-typography__StyledAnchorTag"
})(["&&&{font-family:", ";font-weight:", ";font-size:", ";line-height:", ";text-decoration:underline;cursor:pointer;", " ", "}"], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, function (props) {
  return props.secondary ? props.theme.fontSmallSize : props.theme.fontMediumSize;
}, function (props) {
  return props.secondary ? props.theme.fontSmallLineHeight : props.theme.fontMediumLineHeight;
}, inlineIcon, function (_ref4) {
  var danger = _ref4.danger;
  if (danger) {
    return "\n      color: ".concat(_theme["default"].colors.dangerLink, ";\n      ").concat(linkIconColorAndHeight(_theme["default"].colors.dangerLink), "\n\n      &:hover, &:focus {\n        color: ").concat(_theme["default"].colors.dangerLinkHover, ";\n        ").concat(linkIconColorAndHeight(_theme["default"].colors.dangerLinkHover), "\n      }\n      ");
  } else {
    return "\n      color: ".concat(_theme["default"].colors.link, ";\n      ").concat(linkIconColorAndHeight(_theme["default"].colors.link), "\n      &:hover, &:focus {\n        color: ").concat(_theme["default"].colors.linkHover, ";\n        ").concat(linkIconColorAndHeight(_theme["default"].colors.linkHover), "\n      }\n      ");
  }
});
var Eyebrow = exports.Eyebrow = _styledComponents["default"].span.withConfig({
  displayName: "internal-typography__Eyebrow"
})(["font-family:", ";font-weight:", ";font-size:0.875rem;line-height:1.25rem;color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, _theme["default"].colors.primary, spacingReset, inlineIcon);
Eyebrow.displayName = 'Eyebrow';
var ChipText = exports.ChipText = _styledComponents["default"].span.withConfig({
  displayName: "internal-typography__ChipText"
})(["font-family:", ";font-weight:", ";font-size:0.875rem;color:", ";", " ", " ", ";"], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, _theme["default"].colors.primary, spacingReset, inlineIcon, function (_ref5) {
  var $truncated = _ref5.$truncated;
  return $truncated && overflowStyling;
});
ChipText.displayName = 'ChipText';
var DangerChipText = exports.DangerChipText = (0, _styledComponents["default"])(ChipText).withConfig({
  displayName: "internal-typography__DangerChipText"
})(["color:", ";"], _theme["default"].colors.dangerChip);
DangerChipText.displayName = 'DangerChipText';
var UnavailableChipText = exports.UnavailableChipText = (0, _styledComponents["default"])(ChipText).withConfig({
  displayName: "internal-typography__UnavailableChipText"
})(["text-decoration:line-through;"]);
UnavailableChipText.displayName = 'UnavailableChipText';
var TagText = exports.TagText = _styledComponents["default"].span.withConfig({
  displayName: "internal-typography__TagText"
})(["font-family:", ";font-weight:", ";font-size:0.75rem;line-height:1.25rem;color:", ";", " ", " vertical-align:text-bottom;"], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, _theme["default"].colors.primary, spacingReset, inlineIcon);
TagText.displayName = 'TagText';
var Legend = exports.Legend = _styledComponents["default"].legend.withConfig({
  displayName: "internal-typography__Legend"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:1.125rem;color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.medium, function (props) {
  return props.theme.typographyLegendSize;
}, _theme["default"].colors.formLabel, spacingReset, inlineIcon);
var InputOption = exports.InputOption = _styledComponents["default"].label.withConfig({
  displayName: "internal-typography__InputOption"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, function (props) {
  return props.theme.fontMediumSize;
}, function (props) {
  return props.theme.fontMediumLineHeight;
}, _theme["default"].colors.primary, spacingReset, inlineIcon);
var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "internal-typography__StyledLabel"
})(["font-family:", ";font-weight:", ";font-size:0.8125rem;line-height:1.125rem;", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.medium, spacingReset, inlineIcon);
var Label = exports.Label = (0, _styledComponents["default"])(StyledLabel).withConfig({
  displayName: "internal-typography__Label"
})(["color:", ";"], _theme["default"].colors.formLabel);
var RequiredText = exports.RequiredText = (0, _styledComponents["default"])(StyledLabel).withConfig({
  displayName: "internal-typography__RequiredText"
})(["color:", ";"], _theme["default"].colors.required);
var ErrorLabel = exports.ErrorLabel = (0, _styledComponents["default"])(StyledLabel).withConfig({
  displayName: "internal-typography__ErrorLabel"
})(["color:", ";"], _theme["default"].colors.error);
var ActiveLabel = exports.ActiveLabel = (0, _styledComponents["default"])(StyledLabel).withConfig({
  displayName: "internal-typography__ActiveLabel"
})(["color:", ";"], _theme["default"].colors.active);
var HelperText = exports.HelperText = _styledComponents["default"].span.withConfig({
  displayName: "internal-typography__HelperText"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";"], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, function (props) {
  return props.theme.fontSmallSize;
}, function (props) {
  return props.theme.fontSmallLineHeight;
}, _theme["default"].colors.helper);
var DangerHelperText = exports.DangerHelperText = (0, _styledComponents["default"])(HelperText).attrs({
  'aria-live': 'polite'
}).withConfig({
  displayName: "internal-typography__DangerHelperText"
})(["color:", ";"], _theme["default"].colors.dangerHelper);
var TabText = exports.TabText = _styledComponents["default"].span.withConfig({
  displayName: "internal-typography__TabText"
})(["", " ", ""], bodyStyles, function (_ref6) {
  var $isSelected = _ref6.$isSelected;
  return $isSelected && (0, _styledComponents.css)(["color:", ";"], _theme["default"].colors.active);
});
var ListViewHeader = exports.ListViewHeader = _styledComponents["default"].p.withConfig({
  displayName: "internal-typography__ListViewHeader"
})(["font-family:", ";font-weight:", ";font-size:0.875rem;line-height:1.25rem;color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.medium, _theme["default"].colors.listViewHeader, spacingReset, inlineIcon);
var ListViewPrimaryCell = exports.ListViewPrimaryCell = _styledComponents["default"].p.withConfig({
  displayName: "internal-typography__ListViewPrimaryCell"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.medium, function (props) {
  return props.theme.fontMediumSize;
}, function (props) {
  return props.theme.fontMediumLineHeight;
}, _theme["default"].colors.listViewPrimaryCell, spacingReset, inlineIcon);
var ListViewSecondaryCell = exports.ListViewSecondaryCell = _styledComponents["default"].p.withConfig({
  displayName: "internal-typography__ListViewSecondaryCell"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, function (props) {
  return props.theme.fontMediumSize;
}, function (props) {
  return props.theme.fontMediumLineHeight;
}, _theme["default"].colors.listViewSecondaryCell, spacingReset, inlineIcon);
var ListViewSecondaryInformation = exports.ListViewSecondaryInformation = _styledComponents["default"].p.withConfig({
  displayName: "internal-typography__ListViewSecondaryInformation"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, function (props) {
  return props.theme.fontSmallSize;
}, function (props) {
  return props.theme.fontSmallLineHeight;
}, _theme["default"].colors.listViewSecondaryInformation, spacingReset, inlineIcon);